import React, { useState } from "react";
import { Select } from "antd";
import Modal from "../modal";

/**
 * Modal for selecting review options when marking a document as reviewed
 * with unreviewed sections.
 */
const ReviewOptionsModal = ({ visible, onCancel, onConfirm }) => {
    const [selectedOption, setSelectedOption] = useState("reviewed-only");

    const handleOptionChange = (value) => {
        setSelectedOption(value);
    };

    const handleOk = () => {
        onConfirm(selectedOption);
        setSelectedOption("reviewed-only");
    };

    const handleCancel = () => {
        setSelectedOption("reviewed-only");
        onCancel();
    };

    return (
        <Modal
            visible={visible}
            title="Complete Your Review"
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Complete"
            cancelText="Cancel"
        >
            <p style={{ marginBottom: 16 }}>
                You still have unreviewed sections. How would you like to continue?
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <Select className="select" value={selectedOption} onChange={handleOptionChange}>
                    <Select.Option value="reviewed-only">
                        Include only my reviewed sections
                    </Select.Option>

                    <Select.Option value="all-sections">Include all sections</Select.Option>
                </Select>
            </div>
        </Modal>
    );
};

export default ReviewOptionsModal;
